export default "__VITE_ASSET__00x1YBKP__"